import type {
  IqeRunLogsRequest,
  IqeRunResultsRequest,
} from '../../interfaces/api/requests/runResults.request';

export function toIqeRunLogsUrl(request: IqeRunLogsRequest): string {
  const identifiers = [request.apmNumber, request.projectId, request.runId];
  if (
    identifiers.some(
      identifier =>
        !identifier.trim() || identifier === '.' || identifier === '..',
    )
  ) {
    throw new Error('APM number, project ID and run ID are required.');
  }
  return `service/iqe/${encodeURIComponent(
    request.apmNumber,
  )}/project/${encodeURIComponent(request.projectId)}/runs/${encodeURIComponent(
    request.runId,
  )}/logs`;
}

export function toIqeRunResultsUrl({
  apmNumber,
  projectId,
  runId,
  type,
}: IqeRunResultsRequest): string {
  return `service/iqe/${apmNumber}/project/${projectId}/runs/${runId}/results?type=${type}`;
}
